import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prada-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss']
})
export class HeaderLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
